package kangaroorewards.appsdk.core.utils

/**
 * Empty action. Often used in When() statements
 */
val doNothing: Unit = Unit